import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
// Api and Hook Imports
import UseProjectConfig from '../../../hooks/UseProjectConfig';
import UseQueryProject from '../../../hooks/UseQueryProject';
import UseCustomField from '../../../hooks/UseCustomField';
import { useApi } from '../../../hooks/UseApi';
import FolderApi from '../../../api/FolderApi';
// Design System Imports
import { Input, Button } from '../../../designSystem/DesignSystem';
import { Modal } from '../../../components/modal';
import EntityCustomFieldForm from '../../../components/customField/EntityCustomFieldForm';

import { isValidValue, editModalMapping } from '../../../helpers/Helper';
import { getArtifactName } from '../../../helpers/ArtifactNameHelper';
import { getCustomFields, createEntityFields } from '../../../helpers/CustomFieldHelper';
import { ENTITY_TYPES } from '../../../constants';
import { INFO_MESSAGES, showErrorMes, showSuccessMes } from '../../../helpers/NotificationHelper';
import { useTranslation } from 'react-i18next';
import { titleTranslation } from '../../../helpers/TranslationHelper';
import Markdown from '../../../components/markdown/Markdown';

const FolderModal = (props) => {
  const { isOpen, data, closeModal, parentId } = props;
  const { projectId } = UseQueryProject('projectId');
  const projectConfig = UseProjectConfig(projectId);
  const entityCustomFields = UseCustomField(projectId, ENTITY_TYPES.FOLDER);
  const { control, handleSubmit, setValue, reset } = useForm({
    mode: 'onBlur',
    shouldFocusError: true,
    criteriaMode: 'all'
  });
  const [dataForm, setDataForm] = useState({});
  const [cFields, setCFields] = useState([]);
  const [customFieldForm, setCustomFieldForm] = useState({});
  const { t } = useTranslation();

  const createEditFolder = useApi({
    name: 'saving folder',
    api: isValidValue(data) ? FolderApi.edit : FolderApi.create,
    onSuccess: () => {
      closeModal(createEditFolder?.data);
      showSuccessMes(INFO_MESSAGES.save);
    },
    onError: (err) => showErrorMes(err)
  });

  const onSubmit = (form) => {
    let cFieldForm = getCustomFields(cFields, form);
    const body = {
      ...(isValidValue(data) && { id: data?.id }),
      ...(isValidValue(parentId) && { parentId: parentId }),
      name: form?.name,
      description: isValidValue(form?.description) ? form?.description : '',
      projectId: projectId,
      customFields: createEntityFields(form, cFieldForm)
    };
    createEditFolder.execute(body);
  };

  useEffect(() => {
    if (isValidValue(data)) {
      let mappedArray = editModalMapping(data);
      mappedArray.forEach(({ name, value }) => setValue(name, value));
      setDataForm(data);
    }
  }, []);

  return (
    <>
      <Modal
        open={isOpen}
        close={() => closeModal}
        w={'md'}
      >
        <Modal.Title>{titleTranslation(getArtifactName(projectConfig, ENTITY_TYPES.FOLDER), data, '', t)}</Modal.Title>
        <form
          className="flex flex-grow flex-col gap-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Modal.Content h={'md'}>
            <div className="flex flex-grow flex-col gap-4">
              <Input
                required
                name="name"
                label={t('Name')}
                placeholder={t('name_entity', { entity: getArtifactName(projectConfig, ENTITY_TYPES.FOLDER) })}
                control={control}
                maxLength="255"
              />
              <EntityCustomFieldForm
                customFieldForm={customFieldForm}
                setCustomFieldForm={setCustomFieldForm}
                control={control}
                setValue={setValue}
                entityFields={data?.customFields}
                entityCustomFields={entityCustomFields}
                dataForm={dataForm}
                customControlForJiraModal={false}
                setCFields={setCFields}
              />
              <Markdown
                control={control}
                name="description"
                label={t('Description')}
              />
            </div>
          </Modal.Content>
          <Modal.Buttons>
            <Button
              id="folder-cancel-button"
              secondary
              text={t('Cancel')}
              onClick={() => {
                closeModal();
                reset();
              }}
            />
            <Button
              id="folder-submit-button"
              primary
              text={t('Submit')}
              type="submit"
              loading={createEditFolder?.loading}
            />
          </Modal.Buttons>
        </form>
      </Modal>
    </>
  );
};
export default FolderModal;
